import type { FaireProductEntity } from "../../entity_types/product";

export const p_pgj3q8k53q: FaireProductEntity = {
  token: "p_pgj3q8k53q",
  type: "product",
  name: "Thank You No. 01",
  brandToken: "b_umfa9a7xcn",
  brandName: "Jaymes Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/b7046a2c6bc628edb4d2bdff7ef8e39f60d024d7e9e8c4125ee7075ca2f44423.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2b16f3ed12da0715b6b17608a226821d2ecb6876186b3805229f8d6d2ee5d097.png",
    "https://cdn.faire.com/fastly/8531d094a40dddafb8bbb1384734f83aeb31c337fc40c9c7c5bbe15f58841464.png",
    "https://cdn.faire.com/fastly/e55a24434df9de8885820a81b294009e2cea845de345c3e934f3f70f54b8697e.jpeg",
    "https://cdn.faire.com/fastly/0e2d6a306b0ba53889fb9a084c80d429fda166060225a032afd38d980cf3d13d.jpeg",
    "https://cdn.faire.com/fastly/f0acae1ed3c90495c1d50cc6bd959ae85a5043aba4ef75acf97952642f97e3be.jpeg",
    "https://cdn.faire.com/fastly/6f4cb5100009e2c91b579a84b2b00d21bdae7fcfe48c3abd4f50d7599b6d2442.jpeg",
    "https://cdn.faire.com/fastly/3cb0dafa8c94318e235c7d4ac9354ec6538628fba95b1794cd69a319116d77b7.jpeg",
    "https://cdn.faire.com/fastly/8cdb2f021aaaff9ed5733210348c3a7ca5a3264e37a205e32b5a38fd005010ed.jpeg",
    "https://cdn.faire.com/fastly/0bf62650bf06ae9a141a550bd09ce4d6930409e8c93c8fe4caea51b8bf4f4206.jpeg",
  ],
  priceDollars: 3.75,
  description:
    '\n * A2 Folded 4.25" L × 5.5" W \n * "Can\'t Thank You Enough" \n * Available in Natural, Olive, & Ochre Cover Stock \n * Letterpress \n * Natural Envelope \n * Blank interior \n * Made in Los Angeles\n\n',
  tags: [],
  msrpDollars: 7.5,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:50.821Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
